import { X } from "lucide-react";
import { getVoucherImageSrc } from "@/features/vouchers/config/voucher.config";
import type { VoucherEmployee } from "@/features/vouchers/types/voucherEmployee.type";
import { H2 } from "@/shared/ui/typographies/h2";

type VoucherDrawerHeaderProps = {
  voucher: VoucherEmployee
  onClose: () => void
};

export const VoucherDrawerHeader = ({
  voucher,
  onClose,
}: VoucherDrawerHeaderProps) => {
  const imageSrc = getVoucherImageSrc(voucher);

  return (
    <header className="sticky top-0 z-10 bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-700">
      <div className="flex items-center justify-between px-4 py-3 sm:px-6">
        <button
          type="button"
          onClick={onClose}
          className="p-2 -ml-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
          aria-label="Fermer"
        >
          <X size={20} className="text-slate-600 dark:text-slate-400" />
        </button>
      </div>

      <div className="px-4 pb-4 sm:px-6">
        <div className="flex items-start gap-3">
          <img
            src={imageSrc}
            alt=""
            className="h-12 w-12 object-contain flex-shrink-0"
          />
          <div className="flex-1 min-w-0">
            <H2 className="truncate">{voucher.voucher_campaign_name}</H2>
            <span className="text-sm text-slate-500 dark:text-slate-400">
              Détails et historique des dépenses
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

VoucherDrawerHeader.displayName = "VoucherDrawerHeader";
